import { Download } from "components/icons/generated";
import LinkButton, { LinkButtonProps } from "ds/components/Button/LinkButton";
import Tooltip from "ds/components/Tooltip";

import { createUrl, toBlob } from "./utils";

type DownloadFileButtonProps = {
  fileName: string;
  value: string;
  title: string;
  tooltip?: string;
  variant?: LinkButtonProps["variant"];
  size?: LinkButtonProps["size"];
  onClickCapture?: () => void;
};

const DownloadFileButton = ({
  fileName,
  value,
  title,
  tooltip,
  size = "small",
  variant = "secondary",
  onClickCapture,
}: DownloadFileButtonProps) => {
  const href = createUrl(toBlob(value));

  return (
    <Tooltip
      active={!!tooltip}
      on={(props) => (
        <LinkButton
          {...props}
          download={fileName}
          variant={variant}
          startIcon={Download}
          size={size}
          href={href}
          onClickCapture={onClickCapture}
        >
          {title}
        </LinkButton>
      )}
    >
      {tooltip}
    </Tooltip>
  );
};

export default DownloadFileButton;
